import Table from 'react-bootstrap/Table';

const StatisticResultTable = ({ resultArr })=> {
    return (
        <Table striped bordered hover size="sm">
            <thead>
            <tr>
                <th className="text-right">Gehdistanz</th>
                <th className="text-right">Einwohner</th>
                <th className="text-right">Tagesbevölkerung</th>
            </tr>
            </thead>
            <tbody>
            {
                resultArr.map((result, idx)=>
                    <tr key={idx}>
                    <td className="text-right">{(result.cutoff).toLocaleString("de-DE")} km</td>
                    <td className="text-right">{(result.hws).toLocaleString("de-DE")}</td>
                    <td className="text-right">{(result.tagbev).toLocaleString("de-DE")}</td>
                </tr>)
            }
            </tbody>
        </Table>
    );
}

export default StatisticResultTable;
